import { DetailsPage } from "./DetailsPage.js";

export default DetailsPage;
